module.exports = __webpack_public_path__ + "img/服务案例01.77a6f6d5.png";